import $ from "jquery";

window.subscribe = async function (e) {
    e = e || window.event;
    e.preventDefault();
    try {
        let email = e.srcElement[0].value;
        let res = await $.post("/api/contacts", { email });
        $(".subscribe_letter").hide();
        $(".thank_subscribe").show();
        if (res && res.challenge) {
            sessionStorage.setItem("challenge", JSON.stringify(res));
            window.open("/challenge", "_self");
        }else{
            window.history.replaceState({}, "", "?customer_posted=true");
          }
    } catch (error) {
        return false;
    }
};
window.moduleScroll = function (module) {
    if($(`div[linkmodule=a${module}]`).length){
        let scroll =document.querySelector(`div[linkmodule=a${module}]`).getBoundingClientRect().top;
        document.documentElement.scrollTop=document.documentElement.scrollTop+scroll;
        document.body.scrollTop=document.body.scrollTop+scroll;
     }
}
let notice_visibility = $("#global_js").data("notice_visibility");
let visibility = $("#global_js").data("visibility");
let transparent_head = $("#global_js").data("transparent_head");
let show_quick_nav = $("#global_js").data("show_quick_nav");
function stickiness(el) {
    let max_top = 0;
    let sectionHeader = $(el);

    if (!sectionHeader.length) return;
    $(window).scroll(function () {
        let top = sectionHeader[0].getBoundingClientRect().top;
        max_top = top > max_top ? top : max_top;
        let app_wrap = $("#app_wrap");
        let sectionHeaderHeight = transparent_head
            ? "0"
            : sectionHeader.outerHeight();
        let app_pd_left = parseInt($("#app").css("padding-left"));
        if ($(window).scrollTop() > max_top + 10) {
            if ($('.section-header').css('position') == 'fixed' || $('.site-header').css('position') == 'fixed') {
                $(".section-header").removeClass("transparent_head");
            }
            sectionHeader.css({
                position: "fixed",
                top: "0",
                "z-index": 201,
                width: isNaN(app_pd_left)
                    ? "100%"
                    : `calc( 100% - ${app_pd_left}px  )`
            });
            if (app_pd_left == 0 && el != ".section-header") {
                let el_height = $(el).height();
                $(".quick-nav").css({
                    position: "fixed",
                    top: el_height,
                    "z-index": 99,
                });
            }
            app_wrap.css({ paddingTop: sectionHeaderHeight + "px" });
        } else {
            app_wrap.css({ paddingTop: "0" });
            if ($('div.fit-quick-nav').length > 0 && show_quick_nav && app_pd_left == 0) {
                sectionHeader.css({
                    position: "relative",
                    width: "100%",
                    top: "unset",
                    zIndex: 201,
                });
                $(".quick-nav").css({ position: "unset" });
            } else {
                $(".section-header").addClass(
                    transparent_head ? "transparent_head" : ""
                );
                sectionHeader.css({
                    // 进入到该函数说明必然有一个visibility、notice_visibility为真，当visibility为真notice_visibility为false 并且开启透明导航时 导航应该为absolute 其他情况都应该为relative
                    position: transparent_head && visibility && !notice_visibility ? "absolute" : "relative",
                    width: "100%",
                    top: "unset",
                    zIndex: 201,
                });
            }
            if ($('.header-right .pricelist').css('display') == "flex") {
                $(".section-header").removeClass("transparent_head");
            }
        }
    });
}
(function () {
    let website_title = $("#global_js").data("website_title");
    if (!website_title) return;
    //初始化时页面的title
    let title_inner_text = $("title")[0].innerText;
    let title_list = [title_inner_text, website_title];
    let timer = null;
    $(window).on("blur", e => {
        let index = 0;
        timer = setInterval(() => {
            index++;
            if (index > 1) index = 0;
            $("title")[0].innerText = title_list[index];
        }, 2000);
    });
    $(window).on("focus", e => {
        clearInterval(timer);
        $("title")[0].innerText = title_inner_text;
    });
})()
$(document).ready(function () {
    if (visibility && notice_visibility) {
        stickiness(".section-header");
    } else if (notice_visibility) {
        stickiness(".section-header-notice");
    } else if (visibility) {
        stickiness(".site-header");
    }
    $(".buy_animate").each(function () {
        $(this)[0].addEventListener("animationend", function () {
            $(this).removeClass('buy_animate_action');
            $('.site-header').removeClass('add_cart_animate');
            $('.site-header').removeClass('add_cart_animate_has_quicknav');
            if($('.athena-guess-ligke').length){
               let scroll =document.querySelector('.athena-guess-ligke').getBoundingClientRect().top;
               document.documentElement.scrollTop=document.documentElement.scrollTop+scroll;
               document.body.scrollTop=document.body.scrollTop+scroll;
            }
        });
    });
});
$(window).resize(function () {
    if (show_quick_nav && $('div.fit-quick-nav').length > 0) {
        if (window.innerWidth < 750) {
            $(".section-header").removeClass("transparent_head");
            $(".section-header").css({ width: '100%' });
            $(".section-header-notice").css({ width: '100%' });
            $(".quick-nav").css({ position: 'unset' });
            $("#app_wrap").css({ paddingTop: 0 });
        }
        else {
            $(".quick-nav").css({ position: 'fixed', top: 0 });
            if(transparent_head) {
                $(".section-header").addClass("transparent_head");
            }
        }
    }
    if ($('div.fit-quick-nav').length > 0 && parseInt($("#app").css("padding-left")) > 0) {
        $("#app_wrap").css({ paddingTop: 0 });
    }
});
